module.exports = __webpack_public_path__ + "static/img/axh.32a7fd0d.png";